/**
 * @generated SignedSource<<432bce9dae880128de00b34f0c7dce3d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CityWalkLayout_cityWalk",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "waypointsCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CityWalkWaypoint",
      "kind": "LinkedField",
      "name": "waypoints",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "element",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CityWalkContribution",
      "kind": "LinkedField",
      "name": "activeContribution",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isComplete",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CityWalkCompleteDialog_cityWalk"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CityWalkComplete_cityWalk"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MapWithSidebarLayout_map"
    }
  ],
  "type": "CityWalk",
  "abstractKey": null
};
})();

node.hash = "b266542ec04d352fded35d8c8b4616ba";

module.exports = node;
